import { useEffect, useState } from "react";

const navLinks = [
  { label: "회사소개", href: "#about" },
  { label: "핵심서비스", href: "#services" },
  { label: "차별점", href: "#why" },
  { label: "프로세스", href: "#process" },
  { label: "문의하기", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/f943031b43fc8da94030f1522c0523e1/6ec30ea469d650b6685d8f11bd18e554.png"
            alt="주식회사 프라임파트너스"
            className="h-9 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(l.href);
              }}
              className="text-sm text-foreground-200 hover:text-primary-500 transition-colors cursor-pointer font-medium tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+827070080070"
            className="text-xs text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-1"></i>070-7008-0070
          </a>
          <button
            onClick={() => handleNav("#contact")}
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            무료 상담 신청
          </button>
        </div>

        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-100 cursor-pointer"
          aria-label="menu"
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/60 px-4 py-4 space-y-2">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(l.href);
              }}
              className="block py-2 text-foreground-200 hover:text-primary-500 text-sm font-medium cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => handleNav("#contact")}
            className="w-full mt-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-3 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            무료 상담 신청
          </button>
        </div>
      )}
    </header>
  );
}